import { useEffect, useRef, useState } from "react";

import api from "@/lib/api";

/**
 * Name type karte hi purane naam dikhane wala khaana.
 *
 * Jahan bhi naam likhna hota hai (customer, supplier, item, kabadi…) wahan lagao —
 * type karte hi milte-julte purane naam neeche aa jayenge, chun lo ya new likhte raho.
 *
 *   <SuggestInput
 *     value={name}
 *     onChange={(v) => setName(v)}
 *     onPick={(row) => { ... })}     // purana chuna to poora record milta hai
 *     source="customers"             // customers | products | suppliers | scrap-buyers
 *     placeholder="Enter name"
 *     className="input"
 *   />
 */
const ENDPOINT = {
  customers: "/customers",
  products: "/products",
  suppliers: "/suppliers",
};

export default function SuggestInput({
  value,
  onChange,
  onPick,
  source = "customers",
  placeholder = "",
  className = "input",
  inputProps = {},
  minChars = 1,
  limit = 6,
  label,          // (row) => string   — kya dikhana hai
  sub,            // (row) => string   — neeche chhoti line
  heading = "Already exists",
}) {
  const [q, setQ] = useState("");
  const [hits, setHits] = useState([]);
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    const t = (q || "").trim();
    if (t.length < minChars) { setHits([]); return; }
    const ep = ENDPOINT[source];
    if (!ep) { setHits([]); return; }
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.get(ep, { params: { q: t, limit } });
        setHits(Array.isArray(data) ? data.slice(0, limit) : []);
      } catch { setHits([]); }
    }, 220);
    return () => clearTimeout(timer);
  }, [q, source, minChars, limit]);

  const showLabel = label || ((r) => r.name || "");
  const showSub = sub || ((r) => {
    const bits = [];
    if (r.mobile) bits.push(r.mobile);
    if (r.sku) bits.push(r.sku);
    if (r.type) bits.push(String(r.type));
    if (r.stock != null) bits.push(`stock ${r.stock}`);
    return bits.join(" · ");
  });

  return (
    <div className="relative" ref={box}>
      <input
        {...inputProps}
        value={value}
        autoComplete="off"
        onChange={(e) => { onChange?.(e.target.value); setQ(e.target.value); setOpen(true); }}
        onFocus={() => { setQ(value || ""); setOpen(true); }}
        onBlur={() => setTimeout(() => setOpen(false), 350)}
        placeholder={placeholder}
        className={className}
      />
      {open && (q || "").trim().length >= minChars && hits.length > 0 && (
        <div
          onMouseDown={(e) => e.preventDefault()}
          className="absolute left-0 right-0 top-full mt-1 glass-strong rounded-xl p-2 z-50 max-h-56 overflow-auto"
        >
          <div className="mono text-[9.5px] uppercase tracking-[0.2em] text-white/40 px-2 pb-1.5">
            {heading}
          </div>
          {hits.map((r) => (
            <button
              key={r.id}
              type="button"
              onMouseDown={(e) => {
                e.preventDefault();
                onChange?.(showLabel(r));
                onPick?.(r);
                setOpen(false);
                setQ("");
              }}
              onClick={(e) => e.preventDefault()}
              className="w-full text-left px-3 py-2 rounded-lg hover:bg-white/[0.06]"
            >
              <div className="text-[13px]">{showLabel(r)}</div>
              {showSub(r) && (
                <div className="mono text-[10.5px] text-white/45">{showSub(r)}</div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
